import React, { useState, useEffect } from 'react'
import { Button, Table } from 'react-bootstrap'
import AddUserModal from '../Modal/AddUserModal';
import { api } from '../../services/api';
import { toast } from 'react-toastify';

const useUserManagement = () => {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchUsers = async () => {
    setIsLoading(true);
    try {
      // Replace with your actual API endpoint for fetching users
      const response = await api.users.getAll();
      const { data } = response;
      
      if (data.status ==='success') {
        setUsers(data?.users);
      } else {
        throw new Error(data.message || 'Failed to fetch users');
      }
    } catch (err) {
      setError(err.message);
      toast.error(err.message || 'Failed to fetch users');
    } finally {
      setIsLoading(false);
    }
  };

  const addUser = async (email,password) => {
    
    setIsLoading(true);
    try {
      const created_by = JSON.parse(localStorage.getItem('user'));
      const createdBy = created_by?.user_id
      const response = await api.users.addUser({email,password,createdBy});
      const {data} = response;

      if (response.status === 200 || response.status === 201) {
        await fetchUsers();
        toast.success(response?.data?.message || 'User Created Successfully')
        // return { success: true, message: 'User created successfully' };
      } else {
        throw new Error(response?.data?.message  || 'Failed to create user');
      }
    } catch (err) {
      // toast.error(err.message || 'Failed to create user');
      console.log(err.message)
      return { success: false, message: err.message || 'Failed to create user' };
    } finally {
      setIsLoading(false);
    }
  };

  const removeUser = async (id) => {
    setIsLoading(true);
    try {
      const response = await api.users.deleteUser({id});
      const { data } = response;
  
      if (response.status === 200) {
        await fetchUsers();
        toast.success(data?.message || 'User removed successfully');
        return { success: true, message: 'User removed successfully' };
      } else {
        throw new Error(data?.message || 'Failed to remove user');
      }
    } catch (err) {
      console.log(err);
      
      setError(err.message);
      toast.error(err.message || 'Failed to remove user');
      return { success: false, message: err.message };
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return {
    users,
    isLoading,
    error,
    addUser,
    removeUser,
  };
};

const UserManagement = () => {
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const { users, isLoading, error, addUser, removeUser } = useUserManagement();

  const handleAddUser = async (email,password) => {
    return await addUser(email,password);
  };

  const handleRemoveUser = async (user_id) => {
    if (window.confirm('Are you sure you want to remove this user?')) {
      const result = await removeUser(user_id);
      // if (!result.success) {
      //   alert(result.message);
      // }
    }
  };

  if (error) {
    return <div className="alert alert-danger">{error}</div>;
  }

  return (
    <div className="d-flex flex-column manage-container">
      <div className="d-flex justify-content-between mb-3">
        <div className='manage-project'>Manage Users</div>
        <Button
          className='create-project'
          onClick={() => setShowAddUserModal(true)}
        >
          Create User
        </Button>
      </div>

      {isLoading ? (
        <div className="text-center">Loading...</div>
      ) : (
        <Table responsive className='manage-project-table'>
          <thead>
            <tr>
              <th style={{ minWidth: '200px' }}>User Email</th>
              <th style={{ minWidth: '150px' }}>Created By</th>
              <th style={{ minWidth: '150px' }}>Created Date</th>
              <th style={{ minWidth: '100px' }}>Time</th>
              <th style={{ minWidth: '150px' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user, index) => {
              const dateObj = new Date(user.created_at);
              const createdDate = dateObj.toLocaleDateString(); // Format: MM/DD/YYYY
              const time = dateObj.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
              return (
                <tr key={user.id || index}>
                  <td style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                    {user.email}
                  </td>
                  <td style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                    {user.created_by_email}
                  </td>
                  <td>{createdDate}</td>
                  <td>{time}</td>
                  <td>
                    <Button
                      variant="danger"
                      className='btn-remove'
                      onClick={() => handleRemoveUser(user.user_id)}
                    >
                      <img src='/assets/icons/remove.svg' alt="Remove" />
                    </Button>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </Table>
      )}

      <AddUserModal
        show={showAddUserModal}
        handleClose={() => setShowAddUserModal(false)}
        onAddUser={handleAddUser}
      />
    </div>
  );
};
export default UserManagement;